import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperPlaneTopRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPaperPlaneTopRight"><Path d="M1.28292 5.65518C0.211094 4.75259 0.852196 3.00379 2.25344 3.00782L21.5861 3.06345C22.726 3.06673 23.4458 4.29004 22.8951 5.28809L13.6836 21.9831C13.0219 23.1824 11.2313 22.9404 10.9116 21.6086L8.59061 11.9376L15.2108 8.44205C15.455 8.31311 15.5484 8.01063 15.4195 7.76643C15.2905 7.52224 14.988 7.42881 14.7439 7.55775L7.85911 11.193L1.28292 5.65518Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaperPlaneTopRight;
